<template>
    <div class="text-f4 font-bold">
        Showing <span v-if="searchState.totalResults >= 10000">over </span
        >{{ searchState.totalResults }} products
        <span v-if="searchTerm"> for "{{ searchTerm }}" </span>
        <span v-if="brandName" class=""> by {{ brandName }} </span>
    </div>
</template>

<script>
import { current } from "@libTs/units-converter";

export default {
    props: {
        searchState: {
            required: true,
            type: Object,
        },
        currentResults: {
            required: true,
            type: Number,
        },
        brandName: {
            type: String,
            required: false,
            default: null,
        },
        searchTerm: {
            type: String,
            required: false,
            default: null,
        },
    },
    computed: {
        start() {
            return this.searchState.totalResults === 0
                ? 0
                : (this.searchState.current - 1) *
                      this.searchState.resultsPerPage +
                      1;
        },
        end() {
            return this.searchState.totalResults <=
                this.searchState.resultsPerPage
                ? this.searchState.totalResults
                : this.start + this.searchState.resultsPerPage - 1;
        },
    },
};
</script>
